// import { fetchManagementList, getListItems, updateListItems } from "@/services/products";
import { getOffersFromList } from "@/services/mulesoft";
import { createAsyncThunk } from "@reduxjs/toolkit";

export const fetchFavoirateOffers = createAsyncThunk(
  "get_fav_offers",
  async (
    payload: {
      cn: string | null;
      preferredLanguage: string | null;
      token:string
    },
    { rejectWithValue }
  ) => {
    try {
      const data = await getOffersFromList({
        preferredLanguage: payload?.preferredLanguage,
        token:payload.token
      });
      return data?.response;
    } catch (error) {
      return rejectWithValue({ error });
    }
  }
);
